module.exports = __webpack_public_path__ + "static/media/18ECA40.55977f65.jpg";